module.exports = __webpack_public_path__ + "img/zoom-100.f6eca6b4.gif";